var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('h1',[_vm._v("This is "+_vm._s(_vm.username)+"'s page")])])}
var staticRenderFns = []

export { render, staticRenderFns }